'use strict'; // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.
var _require =
require('js-sha3'),keccak_256 = _require.keccak_256; // eslint-disable-line
var _require2 =
require('./format'),hexToBytes = _require2.hexToBytes;var _require3 =
require('./types'),isHex = _require3.isHex;

function sha3(value, options) {
  var forceHex = options && options.encoding === 'hex';

  if (forceHex || !options && isHex(value)) {
    var bytes = hexToBytes(value);

    return sha3(bytes);
  }

  var hash = keccak_256(value);

  return '0x' + hash;
}

sha3.text = function (val) {return sha3(val, { encoding: 'raw' });};

module.exports = {
  sha3: sha3 };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/api/lib/util/sha3.js
// module id = 184
// module chunks = 0